<div class="stepper w-full h-full">
  <header class="header modal-header flex flex-col gap-2 h-24 place-content-between">
    <div class="flex justify-between">
      <h2 class="py-1 text-3xl font-bold" [innerHTML]="initialStepper.stepLabel"></h2>
      <button mat-icon-button class="button-close" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="w-full h-[calc(100%-6rem)] flex">
    <nav class="steps-list h-full w-[30%]">
      <div class="input-box m-4 mt-0 w-[95%] max-h-[450px] overflow: scroll;">
        <sp-mat-tree
          [showBorder]="true"
          [matTreeDataSource]="matTreeData"
          [selectAllCheckboxDefault]="true"
          [required]="isMatTreeSelected"
          [showExpandCollapse]="false"
          (nodeList)="selectedFormatList($event)"
        >
        </sp-mat-tree>
        <mat-error *ngIf="isMatTreeSelected" i18n>This Field is required</mat-error>
      </div>
    </nav>
    <div class="step-details modal-body relative">
      <div class="step-data-form modal-main">
        <div class="w-full h-full formFields">
          <form class="w-full h-full" [formGroup]="stepperFormGroups">
            <div class="sections">
              <div class="field-section-group -mx-4">
                <div class="field-control inline-block w-full">
                  <div class="input-box mx-4 mb-4">
                    <span class="field-label" i18n>Description*</span>
                    <div>
                      <sp-editor id="textareaEditor" class="block" formControlName="description"> </sp-editor>
                      <mat-error class="text-xs pl-3" *ngIf="stepperFormGroups.controls['description'].errors?.['required']" i18n>Description is required</mat-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <footer class="footer modal-footer">
              <div class="button-row">
                <div class="right-actions float-right inline-block ml-16">
                  <button type="button" [disabled]="stepperFormGroups.invalid || isMatTreeSelected" mat-flat-button class="w-auto button-primary inline-flex gap-1 icon-right" (click)="sendReminder()">
                    <mat-icon matSuffix class="material-icons-outlined !m-0 order-last"> send </mat-icon>
                    <span i18n>Send</span>
                  </button>
                  <div class="clearfix"></div>
                </div>
              </div>
            </footer>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
